<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-12" v-show="isLoading">
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status" >
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

            </div>
        </div>
        <div class="row ">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <!--<h4 class="card-title mb-4">Registro de socios</h4>-->

                        <form @submit="formSubmit">
                          <div class="form-group row m-b-15">
                            <label class="col-sm-3 col-form-label">Estado</label>
                            <div class="col-sm-9">
                              <select class="form-control" v-model="model.estado">
                                <option value="1">Activo</option>
                                <option value="0">Inactivo</option>
                              </select>
                            </div>

                          </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">DNI</label>
                                <div class="col-sm-9">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="DNI"  v-model="model.dni" required>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" type="button">Buscar</button>
                                    </div>
                                </div>
                                </div>

                            </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Apellidos y nombres</label>
                                <div class="col-sm-9">
                                    <input class="form-control" type="text"   v-model="model.nombres" placeholder="Ingrese el nombre"  required />
                                </div>
                            </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Usuario</label>
                                <div class="col-sm-9">
                                    <input class="form-control" type="text"   v-model="model.usuario" placeholder="Ingrese el usuario"  required />
                                </div>
                            </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Correo electronico</label>
                                <div class="col-sm-9">
                                    <input type="email" class="form-control"   v-model="model.email"  placeholder="ejempo@dominio.com" required />
                                </div>
                            </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Celular</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control"   v-model="model.celular"  required />
                                </div>
                            </div>

                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Roles</label>
                                <div class="col-sm-9">
                                    <v-select
                                            :options="roles"
                                            v-model="model.roles"
                                            aria-placeholder="Selecione"
                                            :multiple="true"
                                            label="name"
                                            required>
                                    </v-select>
                                </div>
                            </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Obras</label>
                                <div class="col-sm-9">
                                    <v-select
                                            :options="obras"
                                            v-model="model.obras"
                                            aria-placeholder="Selecione"
                                            :multiple="true"
                                            label="descripcion"
                                            >
                                    </v-select>
                                </div>
                            </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Password</label>
                                <div class="col-sm-9">
                                    <input type="password" class="form-control"
                                           v-bind:class="{ 'is-invalid': errorPasswordNotEqual }"
                                           v-on:input="resetError"
                                           v-model="model.password"
                                           placeholder="Password"
                                           autocomplete="new-password"


                                    />
                                </div>
                            </div>
                            <div class="form-group row m-b-15">
                                <label class="col-sm-3 col-form-label">Reingrese el Password</label>
                                <div class="col-sm-9">
                                    <input
                                        type="password"
                                        class="form-control"
                                        v-bind:class="{ 'is-invalid': errorPasswordNotEqual }"
                                        v-on:input="resetError"
                                        placeholder="Password"
                                        v-model="model.password2"
                                        autocomplete="chrome-off"
                                    />
                                    <div class="invalid-feedback" >
                                        Las contraseñas deben ser iguales
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-md-7 offset-md-3">
                                    <button type="submit" class="btn btn-primary m-r-5" :disabled='isLoading' > {{ this.isLoading?'Guardando...':'Guardar' }}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </Layout>





</template>

<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import PageHeader from "@/components/page-header";



    export default {



        page: {
            title: "Usuarios",
            meta: [{ name: "description", content: appConfig.description }],
        },
        components: {
            Layout,
            PageHeader,
        },
        name: "Users-formulario",
        data(){
            return {
                title: "Usuarios",
                items: [
                    {
                        text: "Administración",
                        href: "/",
                    },
                    {
                        text: "Usuarios",
                        active: true,
                    },
                ],
                roles:[],
                errorPasswordNotEqual:false,
                isLoading:false,
                model: {

                },
                output:"",
                indicadores:[],

                obras:[]
            }
        },
        methods:
            {
                resetError()
                {
                    this.errorPasswordNotEqual=false

                },
                formSubmit(e) {
                    e.preventDefault();
                    if(this.model.password!==this.model.password2)
                    {
                        this.errorPasswordNotEqual=true;
                        return;
                    }
                    //let currentObj = this;
                    this.isLoading=true;
                    this.axios.post(process.env.VUE_APP_BACKEND + '/api/usuarios', {
                        model: this.model
                    })
                        .then((response) =>{
                            if(response.data.success)
                            {
                                this.$swal('Ok',response.data.mensaje,'success');
                                this.$router.push('/administracion/usuarios');
                            }
                        })
                        .catch((error) =>{
                            if (error.response) {

                                this.$swal('Error',error.response.data.mensaje,'warning');
                            }
                            else
                            {
                                this.$swal('Error',"Server error",'error');
                            }

                        })
                        .finally(()=>this.isLoading=false);
                }
            },
        mounted() {
            if(!isNaN(this.$route.params.id))
            {
                //console.log(this.$parent);
                this.isLoading=true;
                this.axios.get(process.env.VUE_APP_BACKEND + '/api/usuarios/'+this.$route.params.id)
                    .then( (response)=>
                    {
                        this.model=response.data;

                    }).finally(()=>this.isLoading=false);
            }
            else
            {
                this.model ={
                    'usuario':'',
                    'email':'',
                    'dni':'',
                    'password':'',
                    'password2':''
                };


            }

            this.axios.get(process.env.VUE_APP_BACKEND + '/api/roles')
                .then(response=>{
                    this.roles=response.data;
                });

            this.axios.get(process.env.VUE_APP_BACKEND+'/api/obras')
            .then((response)=>{
                this.obras=response.data;
            })


        }
    }
</script>

<style scoped>

</style>
